<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2024-03-18 10:48:11
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2025-04-23 10:10:11
 * @FilePath: /epec-guokan-bidding-v2/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/errorPage/errorPage404.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="error-page">
    <div class="error-img">
      <img src="@/assets/img/errorImg/error403.jpg" alt="" />
    </div>
    <p class="error-msg">您缺少使用此功能的相应权限，请联系公司管理员申请。</p>
    <!-- <div class="error-btn">
      <el-button type="primary" @click="goback">返回上一页</el-button>
      <el-button type="primary" @click="gogoHome">返回首页</el-button>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  computed: {},
  mounted() {},
  methods: {
    goback() {
      this.$router.go(-1);
    },
    gogoHome() {
      this.$router.push({
        path: "/",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.error-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .error-img {
    width: 680px;
    height: 400px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .error-msg {
    margin-top: 30px;
    font-size: 20px;
    color: #4f4f4f;
  }
  .error-btn {
    margin-top: 20px;
    .el-button:last-child {
      margin-left: 30px;
    }
  }
}
</style>
